import { useState } from 'react'
import './Mosaic.css'

interface Combo {
  graph: string
  pipe: string
  pressure?: string
}

interface IProps {
  combos: Combo[]
}

function Mosaic (props: IProps) {
  const [currentIndex, setCurrentIndex] = useState<number | undefined>(
    undefined
  )
  const [modalIsOpen, setIsOpen] = useState<boolean>(false)

  const onClickCombo = (index: number) => {
    if (isValid(index)) {
      setCurrentIndex(index)
      setIsOpen(true)
    }
  }

  const isValid = (index: number | undefined) =>
    index !== undefined && index >= 0

  return (
    <div className={`mosaic ${props.combos.length === 1 ? 'mosaic-solo' : ''}`}>
      {modalIsOpen === true && currentIndex !== undefined && (
        <div className="modal-mosaic">
          <div className="modal-bottom" onClick={() => setIsOpen(false)}></div>
          <div className="modal-content">
            <div className="modal-content-images">
              <img src={props.combos[currentIndex].graph} />
              <img src={props.combos[currentIndex].pipe} />
              {props.combos[currentIndex].pressure && (
                <img src={props.combos[currentIndex].pipe} />
              )}
            </div>
          </div>
        </div>
      )}
      {props.combos.map((combo, index) => (
        <div
          key={index}
          className="mosaic-combo"
          onClick={() => onClickCombo(index)}
        >
          <img src={combo.graph} />
          <img src={combo.pipe} />
          {combo.pressure && <img src={combo.pipe} />}
        </div>
      ))}
    </div>
  )
}

export default Mosaic
